import { render } from "./Notifications.vue?vue&type=template&id=63d73d5f"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/Notifications.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63d73d5f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63d73d5f', __exports__)) {
    api.reload('63d73d5f', __exports__)
  }
  
  module.hot.accept("./Notifications.vue?vue&type=template&id=63d73d5f", () => {
    api.rerender('63d73d5f', render)
  })

}


export default __exports__